<template>
  <ul class="peroid-picker">
          <li
            v-for = "period in list"
            :ref="'peroid-card-'+period.time"
            :key="period.time"
            @click="onChangePeriodHandler(period)"
            :class="classnames(period)">
              {{period.time}}
          </li>
  </ul>
</template>
<style lang="less" src="./PeriodPicker.less"></style>
<script>
import {mapState} from 'vuex'
import _ from 'lodash'
import utils from '@/common/libs/utils'
import api from '@/common/libs/api'
export default {
  name: 'PeriodPicker',
  /**
   * startDate: 2019-12-20格式或2019/12/20格式
   * endDate: 2019-12-20格式或2019/12/20格式
   * checkedList: 选中时段列表
   * isMulti: 是否多选，多选表示当天允许多次课
   */
  props: {
    list: {
      type: Array,
      default(){
        return [];
      }
    },
    isMulti: {
      type: Boolean,
      default(){
        return false
      }
    },
    checkedList: {
      type: Array,
      default(){
        return []
      }
    },
    datesGroup: {
      type: Array,
      default(){
        return []
      }
    },
    rate: Number,
    startDate: String,
    endDate: String,
    groupId: String
  },
  data() {
    return {}
  },
  computed: mapState({
    submitForm: state => state.newsign.submitForm
  }),
  methods: {
    //TODO disabled根据disabledGroupIds数组比对
    disabled(periodItem){
        var startDate = this.startDate&&this.startDate.replace(/-/g, '/');
        var endDate = this.endDate&&this.endDate.replace(/-/g, '/');
        var allDays = [];
        var intersection =[];
       
        if (this.rate==api.CodeMap.NewSignCourseRateEnum.Daily){
           console.log("当前时段：", periodItem, ',rate:', this.rate, ',groupid:', this.groupId, ',startDate:', startDate, ',endDate:', endDate);
            allDays = this.getAllDays(new Date(startDate), new Date(endDate));
            intersection = _.intersection(allDays, periodItem.disabledDateGroupIds);
            if (intersection.length>0){
                return true;
            } else {
                return false;
            }
        } else if (this.rate==api.CodeMap.NewSignCourseRateEnum.Weekly&&this.groupId){
           console.log("当前时段：", periodItem, ',rate:', this.rate, ',groupid:', this.groupId, ',startDate:', startDate, ',endDate:', endDate);
             allDays = this.getAllDaysInGroup(new Date(startDate), new Date(endDate), this.groupId);
             
             allDays = _.map(allDays, item => {
                 return item.date;
             });
             intersection = _.intersection(allDays, periodItem.disabledDateGroupIds);
            if (intersection.length>0){
                return true;
            } else {
                return false;
            }
        }
    },
       getAllDays(startDate, endDate){
        var result = [];
        for (var k=startDate.valueOf();k<=endDate.valueOf();){
            var temp = new Date(k);
            result.push(utils.formatDate(temp, 'yyyy-MM-dd'));
            k = k+1000*60*60*24;
        }
        return result;
    },
    getAllDaysInGroup(startDate, endDate, groupId){
        var startDateFmt = utils.formatDate(startDate, 'yyyy-MM-dd');
        var endDateFmt = utils.formatDate(endDate, 'yyyy-MM-dd');
        var dates = _.filter(this.datesGroup, dateItem => {
            if (groupId==dateItem.groupId&&dateItem.date>=startDateFmt&&dateItem.date<=endDateFmt){
                return true;
            } else {
                return false;
            }
        });
        return dates;
    },
    classnames(period){
      var selected = false;
      if (this.isMulti){ //多选
        selected = this.checkedList.indexOf(period.time)>-1;
      } else {
        selected = this.submitForm.periodTime === period.time;
      }
      return ["peroid-item",
        {
          disabledActive: this.disabled(period),
          selected: selected
        }];
    },
    onChangePeriodHandler(period){
      if (!this.disabled(period)){
       this.$store.commit('setSubmitForm', {periodTime: period.time});
       this.$emit('onChangePeriodHandler', period);
      }
      if (!this.isMulti){
        this.$refs[`peroid-card-${period.time}`][0].scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/PeriodPicker.vue